var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"help-text"},[_vm._t("text")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sk-folding-cube"},[_c('div',{staticClass:"sk-cube1 sk-cube"}),_vm._v(" "),_c('div',{staticClass:"sk-cube2 sk-cube"}),_vm._v(" "),_c('div',{staticClass:"sk-cube4 sk-cube"}),_vm._v(" "),_c('div',{staticClass:"sk-cube3 sk-cube"})])
}]

export { render, staticRenderFns }